import axios from "axios";
import { isTestMode } from "dashboard-utils";
import { appUrls, endPoints } from "../../constants/urls";
import { MERCHANT_MID, TEST_MERCHANT_MID } from "../../constants/cookieKeys";
import Cookies from 'universal-cookie';

export const fetchTokenInfo = (params) => {
  const cookies = new Cookies();
  const merchantMID =  isTestMode ?  cookies.get(TEST_MERCHANT_MID) : cookies.get(MERCHANT_MID);
  return axios({
    method: "POST",
    url: appUrls.ORCHESTRATION_LAYER + endPoints.SETTINGS.TOKEN_INFO,
    data: { mid: merchantMID },
  });
};
export const fetchMerchantParams = () => {
  return axios({
    method: "GET",
    // url: 'https://demo7403748.mockable.io/params'
    url: appUrls.ORCHESTRATION_LAYER + endPoints.MERCHANT_PARAMS
  });
};
